<div class="bc-container bc-mb-5">
    <div class="bc-row">
        <div class="bc-col-12">
            <app-title-and-breadcrumb [titulo]="titulo"></app-title-and-breadcrumb>
        </div>
    </div>
    <div class="bc-row bc-mt-5">
        <div class="bc-col-12 bc-text-center">
            <p class="sub-titulo-componente">Selecciona alguno de las opciones para ver información de las facturas
            </p>
        </div>
    </div>
    <div class="bc-row bc-mt-5 bc-text-center">
        <div class="bc-col-12">
            <app-buscador-facturas (valoresEvent)="eventoBuscadorFormDataEvent($event)" (searchEvent)="eventoBuscador($event)"></app-buscador-facturas>
        </div>
    </div>
    <div class="bc-row-lg">
        <div class="bc-col-lg-9"></div>
        <div class="bc-col-lg-3">
                        <bc-float-menu *ngIf="floatMenuOptions.length > 0"
                            [options]='floatMenuOptions'
                            floatMenuWidth="full" 
                            [arrowCenter]="true"
                            (onChange)="eventoFiltroEstado($event)" class="btn-filtro-estado">
                                <button 
                                    class="bc-button-primary bc-button-small bc-float-menu-toggle" 
                                    sizeButton="small"                            
                                    typeButton="secondary">Filtro estado<em class="bc-icon" aria-hidden="true">arrow2-down</em>
                                </button>                
                            </bc-float-menu>
    
        </div>
    </div>
    <div class="bc-row-lg bc-mt-5">
        <div class="bc-col-lg-9"></div>
        <div class="bc-col-lg-3">
                        <app-reporte-factura (isErrorEvent)="isErrorExportEvent($event)"
                        [formData]="formData"></app-reporte-factura>
    
        </div>
    </div>
    <div class="bc-row bc-mt-2">
        <div class="bc-col-12"></div>
    </div>
    <div class="bc-row bc-mt-2">
        <div class="bc-col-9"></div>
        <div class="bc-col-3">
                        <app-reporte-vfiscal (isErrorEvent)="isErrorExportEvent($event)"></app-reporte-vfiscal>
    
        </div>
    </div>
    <div class="bc-row-lg bc-mt-5">
        <app-facturas-table [data]="dataFactura" (dataTableEvent)="onChangePageTable($event)"></app-facturas-table>
    </div>
    <div class="bc-row">
        <div class="bc-col-12">
            <app-modal [bandera]="isModal" [title]="titleModal" [typeIcon]="typeIconModal" customWidth="medium"
                [body]="bodyModal" [subBody]="subBodyModal"></app-modal>
        </div>
    </div>
    <div class="bc-row">
        <div class="bc-col-12">
            <bc-circle-loading [text]="circleLoadingText" [accessibilityLabel]="circleLoadingAriaLabel"
                [speedLoader]="loaderSpeed">
            </bc-circle-loading>
        </div>
    </div>
</div>

